import "./index.scss";
import { GeneralSmallArrowRight } from "@wise-emotions/react-icons";
import React, { ReactNode } from "react";
import cn from "classnames";

type Theme = "white" | "black";
type Props = {
  title?: string;
  description?: ReactNode;
  ctaLabel?: string;
  centered?: boolean;
  theme?: Theme;
};

export const CardBlock = ({
  title,
  description,
  ctaLabel,
  centered,
  theme = "black",
}: Props) => {
  return (
    <div
      className={cn("card-block", {
        [`card-block--${theme}`]: theme,
        "card-block--centered": centered,
      })}
    >
      <div>
        {title && <div className="card-block__title">{title}</div>}
        {description && (
          <div className="card-block__description">{description}</div>
        )}
      </div>
      {ctaLabel && (
        <div className="card-block__cta">
          {ctaLabel}
          <GeneralSmallArrowRight />
        </div>
      )}
    </div>
  );
};
